<template>
  <main role="main" class="col content-spacing">
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2">Cupons/Comercializadores</h1>
      <div class="btn-toolbar mb-2 mb-md-0">
        <div class="btn-group mr-2">
          <BaseButtonComponent
            :to="`/coupon-owners/new/${state.coupon}`"
            variant="primary-action"
            >Novo</BaseButtonComponent
          >
        </div>
      </div>
    </div>
    <b-row>
      <b-col>
        <div class="btn-group my-2">
          <BaseButtonComponent to="/coupons" variant="primary-action"
            >Voltar para Cupons</BaseButtonComponent
          >
        </div>
      </b-col>
    </b-row>
    <!--     <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-3"
    >
      <b-form-input
        autofocus
        v-on:keyup.enter="search"
        v-model="viewData.search"
        placeholder="Digite um termo e pressione enter para buscar"
      ></b-form-input>
    </div> -->

    <loading-list v-if="viewData.loading"></loading-list>
    <div
      v-else-if="!viewData.loading && state.list && state.list.length > 0"
      class="table-responsive"
    >
      <table class="table b-table  table-hover table-bordered">
        <thead>
          <tr>
            <td>Cupom</td>
            <td>Comercializador</td>
            <td>Comissão(%)</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.list" :key="item.id">
            <td>{{ item.nameCoupon }}</td>
            <td
              style="display: flex; justify-content: space-between; align-items: center; height: 64px;"
            >
              <span>{{ item.nameAccount }}</span>
              <span
                v-if="item.mainTrader == item.accountId"
                style="border: 2px solid orange; background-color: transparent; color: orange; padding: 0.5rem; border-radius: 0.5rem;"
              >
                Promotor Principal
              </span>
            </td>
            <td>{{ item.comission }}</td>

            <td style="text-align: right">
              <b-overlay
                :show="busy"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block"
              >
                <BaseButtonComponent
                  ref="button"
                  :disabled="busy || item.mainTrader == item.accountId"
                  variant="secondary-action"
                  size="sm"
                  @click="promoteTraderToMain(item.nameCoupon, item.accountId)"
                >
                  Promover a principal
                </BaseButtonComponent>
              </b-overlay>
              <BaseButtonComponent
                :to="`/coupon-owners/edit/${item.id}`"
                size="sm"
                v-b-tooltip.hover
                title="Editar"
                variant="primary-action"
              >
                <b-icon icon="pencil-square" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
              <BaseButtonComponent
                @click="() => remove(item)"
                size="sm"
                v-b-tooltip.hover
                title="Excluir"
                variant="danger"
              >
                <b-icon icon="trash" aria-hidden="true"></b-icon>
              </BaseButtonComponent>
            </td>
          </tr>
        </tbody>
      </table>

      <b-pagination-nav
        class="mt-3"
        :link-gen="linkGen"
        :number-of-pages="state.pageCount"
        use-router
      ></b-pagination-nav>
    </div>
    <empty-list v-else-if="!viewData.loading"></empty-list>
  </main>
</template>

<script>
import helpers from '../../vue/helpers';
import { Api } from '../../vue/api';
import { BaseButtonComponent } from '../../ui/buttons';

const API = new Api();

export default {
  name: 'coupon-owners-index',
  data: function() {
    return {
      state: {
        list: [],
        page: 1,
        pageCount: 1,
        count: 0,
        coupon: 0,
      },
      viewData: {
        loading: true,
        search: '',
      },
      busy: false,
    };
  },
  computed: {},
  beforeMount: async function() {
    if (this.$route.query && this.$route.query.search) {
      this.viewData.search = this.$route.query.search;
    }

    this.state.coupon = this.$route.params.id;

    await this.getAll();
  },
  methods: {
    formatSocialNumber(socialNumber) {
      if (socialNumber.length === 11) {
        return socialNumber.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/g,
          '$1.$2.$3-$4',
        );
      } else {
        return socialNumber.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
          '$1.$2.$3/$4-$5',
        );
      }
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },
    search() {
      this.$router.push({
        query: { page: 1, search: this.viewData.search },
      });
    },
    async getAll() {
      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path:
            `/coupon-owners-list/${this.state.coupon}` +
            helpers.toQueryString(this.$route.query),
          method: 'get',
        });

        this.state = { ...result.model, coupon: this.state.coupon };
        this.viewData.loading = false;
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async remove(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Deseja mesmo excluir [${item.nameAccount}] ?`,
        {
          title: 'Confirmar Exclusão',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'Sim',
          cancelTitle: 'Não',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        },
      );

      if (!ok) {
        return;
      }

      try {
        this.viewData.loading = true;

        const result = await API.post('/execute', {
          path: '/coupon-owners/' + item.id,
          method: 'delete',
        });

        this.$toast.success('Cupom/Comercializador excluída com sucesso');
        await this.getAll();
      } catch (ex) {
        this.$toast.error(helpers.getFirstError(ex));
      }
    },
    async promoteTraderToMain(nameCoupon, accountId) {
      this.busy = true;
      const result = await API.post('/execute', {
        path: `/coupon/add-main-trader/${nameCoupon}/${accountId}`,
        method: 'post',
      });
      console.log(result);
      if (!result) {
        this.$toast.error(helpers.getFirstError(ex));
        this.busy = false;
        return;
      }
      this.busy = false;
      this.$toast.success('Promoter promovido a principal!');
      this.getAll();
    },
  },
  components: {
    BaseButtonComponent,
  },
};
</script>
